<template>
  <EBaseResult
    :title="title"
    :url="url"
    :source="source"
    class="ad-result"
    data-test-id="ad-text-result"
    @title-click="onTitleClick"
  >
    <template #info-start>
      <EAdLabel :tooltip-side="tooltipSide" />
    </template>
    <template v-if="brand" #info-end>
      <EBrand v-bind="brand" />
    </template>
    <template #description>
      <p
        class="ad-result__description"
        data-test-id="ad-result-description"
      >
        {{ description }}
      </p>
    </template>
    <template #content-end>
      <ESmart v-if="smart" v-bind="smart" />
      <EConsumerRatings v-if="consumerRatings" v-bind="consumerRatings" />
      <EMerchantRating v-if="merchantRating" v-bind="merchantRating" />
    </template>
    <template v-if="action" #columns-end>
      <EAction v-bind="action" />
    </template>
    <EDeepLinks
      v-if="deepLinksCapped.length > 0"
      :links="deepLinksCapped"
      :page-position="pagePosition"
      :rank="rank"
      type="ad"
      data-test-id="ad-result-deep-links"
    />
  </EBaseResult>
</template>

<script>

import { trackImpression, trackClick, TYPE_AD } from '~~/search/common/js/client/analytics/results';
import { AD_DEEP_LINKS_TOTAL } from '~~/search/common/js/constants';
import screen from '~~/common/vue/mixins/screen';
import EAdLabel from '~~/common/vue/components/ad-label';
import EBaseResult, { baseProps } from '../base';
import EDeepLinks from '../add-ons/deep-links';
import EAction from './extensions/action';
import EMerchantRating from './extensions/merchant-rating';
import ESmart from './extensions/smart';
import EBrand from './extensions/brand';
import EConsumerRatings from './extensions/consumer-ratings';

export default {
  name: 'EAdResult',
  components: {
    EAdLabel,
    EBaseResult,
    EDeepLinks,
    EAction,
    EMerchantRating,
    EBrand,
    ESmart,
    EConsumerRatings,
  },
  mixins: [screen()],
  props: {
    ...baseProps,
    deepLinks: {
      type: Array,
      default: () => [],
    },
    description: {
      type: String,
      default: '',
    },
    extensions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tooltipSide() {
      return this.isDesktopUp ? 'right-center' : 'left-bottom';
    },
    merchantRating() {
      return this.getExtension('merchantRating');
    },
    action() {
      return this.getExtension('action');
    },
    smart() {
      return this.getExtension('smart');
    },
    consumerRatings() {
      return this.getExtension('consumerRatings');
    },
    brand() {
      return this.getExtension('brand');
    },
    deepLinksCapped() {
      return this.deepLinks.slice(0, AD_DEEP_LINKS_TOTAL);
    },
    trackingOptions() {
      return {
        extensions: this.extensions,
        position: this.pagePosition,
        rank: this.rank,
        title: this.title,
        type: TYPE_AD,
        url: this.source,
      };
    },
  },
  mounted() {
    trackImpression(this.trackingOptions);
  },
  methods: {
    getExtension(extType) {
      const tempExt = this.extensions.find((extension) => extension.type === extType);
      if (tempExt) {
        const { type, ...ext } = tempExt;
        return ext;
      }
      return null;
    },
    onTitleClick() {
      trackClick(this.trackingOptions);
      this.$emit('ad-click');
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-result__description {
  margin: 0;
}

.ad-results__columns {
  display: flex;
}
</style>
